package org.matthewo.hooks

import js.coroutines.awaitCancellation
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import react.useEffectOnce
import react.useMemo

fun useCoroutineScope(): CoroutineScope {
    val scope = useMemo {
        CoroutineScope(SupervisorJob() + Dispatchers.Main)
    }

    useEffectOnce {
        awaitCancellation {
            scope.cancel()
        }
    }

    return scope
}
